import { render, staticRenderFns } from "./poi.vue?vue&type=template&id=ab5adaca&scoped=true&"
import script from "./poi.vue?vue&type=script&lang=js&"
export * from "./poi.vue?vue&type=script&lang=js&"
import style0 from "./poi.vue?vue&type=style&index=0&id=ab5adaca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5adaca",
  null
  
)

export default component.exports